import React from "react";
import "./TermsPage.css";

const TermsPage = () => {
  return (
    <div className="terms-page-wrapper">
      <div className="terms-glow"></div>

      <div className="terms-container">
        {/* Header */}
        <div className="terms-header">
          <h1 className="terms-title">Terms & Conditions</h1>
          <p className="terms-subtitle">
            Welcome to Poonji Mitra! These terms and conditions establish the
            <br />
            rules for using our platform, Poonji Mitra.
          </p>
        </div>

        {/* Content Body */}
        <div className="terms-content">
          <div className="terms-section">
            <h3>1. Introduction</h3>
            <p>
              Welcome to the Poonji Mitra mobile application ("App"), owned and
              operated by <strong>Kanchan Gupta</strong> (ARN 175447) under the
              brand <strong>Poonji Mitra</strong> ("we," "our," or "us"). By
              downloading, accessing, or using our App, you agree to comply with
              these Terms & Conditions. If you do not agree, please refrain from
              using the App.
            </p>
          </div>

          <div className="terms-section">
            <h3>2. Services Offered</h3>
            <p>
              Poonji Mitra offers the following investment-related services:
            </p>
            <ul>
              <li>
                <strong>Mutual Funds</strong>
              </li>
              <li>
                <strong>Bonds</strong>
              </li>
              <li>
                <strong>Initial Public Offerings (IPOs)</strong>
              </li>
              <li>
                <strong>Spenny</strong> (micro-investment service)
              </li>
            </ul>
            <p>
              We act as a registered mutual fund distributor and provide
              investment execution, information, and related services.
            </p>
          </div>

          <div className="terms-section">
            <h3>3. Registration & User Responsibilities</h3>
            <ul>
              <li>You must be at least 18 years old to use the App.</li>
              <li>
                You agree to provide accurate, current, and complete information
                during registration.
              </li>
              <li>
                You are responsible for maintaining the confidentiality of your
                account credentials.
              </li>
            </ul>
          </div>

          <div className="terms-section">
            <h3>4. Disclaimers</h3>
            <ul>
              <li>
                We are a <strong>distributor</strong>, not an investment
                advisor, unless otherwise stated in writing. Investment
                decisions are your sole responsibility.
              </li>
              <li>
                Market investments are subject to risks, including possible loss
                of principal.
              </li>
              <li>Past performance is not indicative of future results.</li>
            </ul>
          </div>

          <div className="terms-section">
            <h3>5. Fees & Charges</h3>
            <ul>
              <li>
                Any fees or commissions applicable is not taken from the client
                directly and rather it is received from the AMC.
              </li>
              <li>
                Mutual fund investments are subject to distributor commissions
                as per regulatory norms.
              </li>
            </ul>
          </div>

          <div className="terms-section">
            <h3>6. Limitation of Liability</h3>
            <p>
              We are not responsible for any losses, damages, or liabilities
              arising from your investment decisions, market fluctuations, or
              system unavailability. Poonjimitra is only an investment platform.
            </p>
          </div>

          <div className="terms-section">
            <h3>7. Regulatory Compliance</h3>
            <p>
              Poonji Mitra operates under ARN 175447 (Kanchan Gupta) and follows{" "}
              <strong>AMFI</strong> and <strong>SEBI</strong> guidelines.
            </p>
          </div>

          <div className="terms-section">
            <h3>8. Modifications</h3>
            <p>
              We reserve the right to modify these Terms at any time. Continued
              use of the App after modifications constitutes acceptance of the
              updated Terms.
            </p>
          </div>

          <div className="terms-section">
            <h3>9. Governing Law</h3>
            <p>
              These Terms are governed by the laws of India. Disputes shall be
              subject to the exclusive jurisdiction of courts in Jaipur,
              Rajasthan.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
